import getWidgetByName from "../requests";
import { Articles } from "../../articles/entities";
import {prop, take} from "ramda";

const getLatestNewsFeaturedWidget = () =>
  getWidgetByName("latest_news_featured_aside_widget")
    .then(Articles)
    .then(prop("articles"))
    .then(take(5))

export { getLatestNewsFeaturedWidget };
